import React, { MouseEvent, ReactElement } from 'react';
import Card from '../main/card';
import { Col, Row } from 'react-bootstrap';
import useTranslate from '../useTranslate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ManagedPartnerDto } from '../../store/partnerManagerSlice';
import useFeatureAccess from '../../util/useFeatureAccess';
import { useNavigate } from 'react-router-dom';

interface Props {
    selectedPartner: ManagedPartnerDto;
}

const COLUMN_SIZE: number = 3;

function FrequentActionCard(props: Readonly<Props>) {
    const navigate = useNavigate();
    const strings = useTranslate('FrequentActionCard');

    const { canWriteFeature } = useFeatureAccess(props.selectedPartner);
    const hasWriteLocation = canWriteFeature('RESIDENTIAL_LOCATION');

    const actions: ReactElement[] = [];

    if (hasWriteLocation) {
        actions.push(
            <Col xs={COLUMN_SIZE} key={'set-prices'}>
                <ActionButton
                    onClick={handleSetPricesClick}
                    iconElement={WeWashShortIcons.moneyChange}
                >
                    {strings.setPricesAction}
                </ActionButton>
            </Col>
        );
    }

    if (actions.length === 0) {
        return null;
    }

    return (
        <Card
            title={strings.title}
            type={'card-primary'}
            // type?: 'card-primary'| 'card-info'| 'card-edit'| 'card-alert'| 'card-add'| '';
        >
            <hr className="divider" />

            <Row>{actions}</Row>
        </Card>
    );

    function handleSetPricesClick(e?: MouseEvent) {
        e?.preventDefault();
        navigate('/select-location-pricing');
    }
}

enum WeWashShortIcons {
    moneyChange = 'money-change',
    discount = 'discount',
}

interface ActionButtonProps {
    key?: string;
    onClick: () => void;
    icon?: IconProp;
    iconElement?: WeWashShortIcons;
    children: string;
}

function ActionButton(props: Readonly<ActionButtonProps>) {
    return (
        <a onClick={handleClick} className={'action-button'}>
            {renderIcon()}
            <div>{props.children}</div>
        </a>
    );

    function handleClick(e: MouseEvent) {
        e?.preventDefault();
        props.onClick();
    }

    function renderIcon() {
        if (props.iconElement) {
            return <div className={`action-icon ${props.iconElement}`} />;
        }
        if (props.icon) {
            return <FontAwesomeIcon icon={props.icon} size={'3x'} />;
        }
        return <div />;
    }
}

export default FrequentActionCard;
